import { render, staticRenderFns } from "./TalkTrendStatsBasePage.vue?vue&type=template&id=1f8c2ec3"
import script from "./TalkTrendStatsBasePage.vue?vue&type=script&lang=js"
export * from "./TalkTrendStatsBasePage.vue?vue&type=script&lang=js"
import style0 from "./TalkTrendStatsBasePage.vue?vue&type=style&index=0&id=1f8c2ec3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports